import React, { Component } from "react";
import "./burger.css";
class Burger extends Component {
    state = {
        clicked: false,
        className: "burger"
    };

    componentDidMount() {
        // let className = this.state.className;
        // className += ` ${this.props.classNames}`;
        // this.setState({className});
        // console.log(className);
    }

    render() {
        let className = this.props.className;
        // console.log(className);
        return (
            <div className={className} onClick={this.props.clickBurger}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        );
    }
}

export default Burger;
